import React, { Component } from 'react';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import { firebase } from '../firebase';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import 'react-block-ui/style.css';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import {
  default as config,
  CONSTANTS,
  USER_STATUS
} from '../constants/constants';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import withAuthorization from '../session/with_authorization';
import Navigation from '../components/header/Navigation';
import claimsObserver from '../session/claims_observer';
import { getUser } from '../redux/actions/user-actions';
import Logo from '../components/widgets/Logo';
import MobileMenu from '../components/header/MobileMenu';
import MobileFooter from '../components/widgets/MobileFooter';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { isUserStatusNew } from '../utils/CheckUserStatus';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class FreeCouponPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coupon: '',
      isLoading: true
    };
  }

  componentDidMount() {
    // go ahead and move user to dashboard....
    // props.dispatch(
    //   getUser(token, () => {
    //     history.push('/dashboard');
    //   })
    // );

    // go ahead, start the free trial and move user to dashboard....
    if (firebase?.auth.currentUser) {
      this.freeTrial();
    } else {
      // sign the user out
    }
  }

  makeUserSignIn = () => {
    swal({
      imageUrl: CONSTANTS.swalLogo,
      title:
        '<div class="titleModal">We\'re sorry, your email<br />hasn\'t been verified yet.</div>',
      html:
        '<p class="contentModal">Please check your email (or spam) inbox<br />or click the button to receive a new verification email.</p>',
      showConfirmButton: true,
      confirmButtonText: 'Resend',
      showCloseButton: false,
      background: '#121C24',
      allowOutsideClick: false
    })
      .then((result) => {
        if (result) {
          currentUser.sendEmailVerification();
          return currentUser.getIdToken();
        }
      })
      .catch(swal.noop);
    firebase.auth().signOut();
  };

  freeTrial = (event) => {
    const { coupon } = this.state;
    const { history } = this.props;
    const props = this.props;

    let token;

    firebase.auth.currentUser
      .getIdToken()
      .then((_token) => {
        token = _token;
        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/auth/freetrial2`,
          params: { coupon }
        };

        return axios(options);
      })
      .then(() => {
        firebase.auth.currentUser.getIdToken(true);
        claimsObserver.broadcast('free');

        return swal({
          imageUrl: CONSTANTS.swalLogo,
          title: '<div class="titleModal">Your free trial has started.</div>',
          html:
            '<p class="contentModal">Please click OK to continue to your dashboard.</p>',
          background: '#121C24',
          confirmButtonColor: '#E31690',
          allowOutsideClick: false,
          showCloseButton: false
        });
      })
      .then(() => {
        props.dispatch(
          getUser(token, () => {
            history.push('/dashboard');
          })
        );
      })
      .catch((error) => {
        if (error.response.status === 403) {
          history.push('/dashboard');
        }

        if (
          error.response &&
          error.response.data.msg === 'This coupon does not exist.'
        ) {
          swal({
            imageUrl: CONSTANTS.swalLogo,
            title: `<div class="titleModal">${error.response.data.msg}</div>`,
            html:
              '<p class="contentModal">Please choose another one or start your free trial with out a coupon.</p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        }
      });
    if (event) {
      event.preventDefault();
    }
  };

  render() {
    return (
      <React.Fragment>
        <BlockUi tag="div" blocking={this.state.loading}>
          <Navigation />
          <div className="main-page" style={{ marginTop: '15px' }}>
            {this.props.error ? (
              <div className="errorMsg">{this.props.error}</div>
            ) : (
              <div className="rounded-container">
                <div
                  className="headerDivDesc"
                  style={{ textAlign: 'center', marginBottom: '25px' }}
                >
                  Welcome to Inflo
                  <br />
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 100,
                      lineHeight: '22px',
                      marginTop: 24
                    }}
                  >
                    {/* To continue with your free trial, please enter the optional
                    coupon code and click START FREE TRIAL below. <br /> */}
                    You're free trial has started and you we are preparing your
                    dashboard now.
                  </div>
                  {/* Free Trial Period */}
                </div>
              </div>
            )}
          </div>
        </BlockUi>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    braintreeToken: store.user.braintreeToken
    // error: store.user.error
  };
};

const authCondition = (authUser) =>
  !!authUser && (!authUser.userStatus || isUserStatusNew(authUser.userStatus));

export default withAuthorization(authCondition)(
  withRouter(connect(mapStateToProps)(FreeCouponPage))
);
